import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActivateRepComponent } from './activate-rep.component';

const routes: Routes = [
  // Module is lazy loaded, see app-routing.module.ts
  {
    path: '',
    component: ActivateRepComponent,
    data: { title: 'Activar representantes médicos' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ActivateRepRoutingModule { }
